import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IDataTableSpacerProps from "./type";
import stylesheet from "./stylesheet";

const DataTableSpacer: FC<IDataTableSpacerProps> = ({
    style,
    ...props
}) => {
    return <View
        {...props}
        style={[
            style,
            stylesheet.container
        ]}
        aria-hidden={true}
    />;
};
export default DataTableSpacer;
